module.exports = __webpack_public_path__ + "static/media/CycleTasks.bb50e161.svg";